import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_URL,
});

API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

// Create Order
export const createOrder = createAsyncThunk<
  any,
  { userId: any; planName: string; planType: string; customDays?: string },
  { rejectValue: string }
>('payment/createOrder', async (payload, { rejectWithValue }) => {
  try {
    const response = await API.post('/payment/create-order', payload);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch plans');
  }
});

// Verify payment after success
export const verifyOrder = createAsyncThunk<
    any,
    { userId: any; razorpayOrderId: string; razorpayPaymentId: string; razorpaySignature: string; amount: string; currency: string},
    { rejectValue: string }
    >("payment/verifyPayment", async (payload, { rejectWithValue }) => {
      try {
        const response = await API.post('/payment/verify-payment', payload);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || "Payment verification failed");
      }
    }
  );

// Fetch Plans
export const fetchPlans = createAsyncThunk<
  any,
  void,
  { rejectValue: string }
>('plans/fetchPlans', async (_, { rejectWithValue }) => {
  try {
    const response = await API.get('/plans');
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch plans');
  }
});

// Add Plan
export const addPlan = createAsyncThunk<
  any,
  { name: string; price: number; features: string[]; badge?: string },
  { rejectValue: string }
>('plans/addPlan', async (payload, { rejectWithValue }) => {
  try {
    const response = await API.post('/plans/add', payload);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to add plan');
  }
});

// Edit Plan
export const editPlan = createAsyncThunk<
  any,
  { id: string; name: string; price: number; features: string[]; badge?: string },
  { rejectValue: string }
>('plans/editPlan', async ({ id, ...payload }, { rejectWithValue }) => {
  try {
    const response = await API.put(`/plans/edit/${id}`, payload);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to edit plan');
  }
});

// Delete Plan
export const deletePlan = createAsyncThunk<
  string,
  { id: string },
  { rejectValue: string }
>('plans/deletePlan', async ({ id }, { rejectWithValue }) => {
  try {
    await API.delete(`/plans/delete/${id}`);
    return id;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to delete plan');
  }
});
